import axios from './index'

// 查询企业概览数据
export const queryOrganizationMetadata = () => {
  return axios.getRequest({
    url: '/api/organization/metadata'
  })
}

// 新增/更新企业概览数据
export const updateOrganizationMetadata = (param) => {
  return axios.httpRequest({
    url: `/api/organization/metadata/property`,
    method: 'put',
    data: param
  })
}

// 修改项目属性
export const updateProjectMetadata = (projectId, param) => {
  return axios.httpRequest({
    url: `/api/project/property/${projectId}`,
    method: 'put',
    data: param
  })
}

// 新增项目属性
export const addProjectMetadata = (projectId, param) => {
  return axios.httpRequest({
    url: `/api/project/property/${projectId}`,
    method: 'post',
    data: param
  })
}

// 删除项目属性
export const deleteProjectMetadata = ({ projectId }) => {
  let propertyName = "dataURL";
  return axios.httpRequest({
    url: `/api/project/property/${projectId}/${propertyName}`,
    method: 'delete',
  })
}



// WEBPACK FOOTER //
// ./src/api/appManagement.js